import { render, staticRenderFns } from "./JumpPage.vue?vue&type=template&id=006a90b0&scoped=true"
import script from "./JumpPage.vue?vue&type=script&lang=js"
export * from "./JumpPage.vue?vue&type=script&lang=js"
import style0 from "./JumpPage.vue?vue&type=style&index=0&id=006a90b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006a90b0",
  null
  
)

export default component.exports